import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLayerGroup } from '@react-icons/all-files/fa/FaLayerGroup';
import ProfaseModal from '../../commons/ProfaseModal';
import PageForm, { FormField } from '../../commons/PageForm';
import { useAppDispatch, useAppSelector } from '../../store';
import { createEntity, reset } from '../../manager/workflow-clase.reducer';

const ACCENT = '#6366f1';

interface ClaseForm {
  nombre: string;
}

const empty: ClaseForm = { nombre: '' };

const fields: FormField<ClaseForm>[] = [
  {
    name:        'nombre',
    label:       'Nombre',
    required:    true,
    placeholder: 'Nombre de la clase',
  },
];

export default function WorkflowClaseNewModal() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const updating      = useAppSelector(s => s.workflowClase.updating);
  const updateSuccess = useAppSelector(s => s.workflowClase.updateSuccess);

  const [form, setForm]     = useState<ClaseForm>(empty);
  const [errors, setErrors] = useState<Partial<Record<keyof ClaseForm, string>>>({});

  useEffect(() => {
    dispatch(reset());
    setForm(empty);
    setErrors({});
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      navigate('/workflow/clases');
    }
  }, [updateSuccess, dispatch, navigate]);

  const close = () => navigate('/workflow/clases');

  const handleFieldChange = (name: keyof ClaseForm, value: string) => {
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const nextErrors: Partial<Record<keyof ClaseForm, string>> = {};
    if (!form.nombre.trim()) nextErrors.nombre = 'El nombre es requerido';
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }
    dispatch(createEntity({ nombre: form.nombre.trim() }));
  };

  return (
    <ProfaseModal
      open
      titleId="workflow-clase-new-modal-title"
      size="compact"
      onBackdropMouseDown={e => {
        if (e.target === e.currentTarget && !updating) close();
      }}
    >
      <div style={s.header}>
        <h2 id="workflow-clase-new-modal-title" className="profase-modal-title m-0">
          <FaLayerGroup style={{ marginRight: 8, verticalAlign: '-2px' }} />
          Nueva Clase
        </h2>
        <button
          type="button"
          className="profase-form-btn-secondary btn-sm"
          onClick={close}
          disabled={updating}
        >
          Cerrar
        </button>
      </div>

      <p className="profase-modal-description">
        Complete los datos para crear una nueva clase de workflow.
      </p>

      <PageForm
        embedded
        fields={fields}
        values={form}
        errors={errors}
        isNew
        saving={updating}
        labelInline
        onFieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        onCancel={close}
        accentColor={ACCENT}
        submitLabel="Crear clase"
        cancelLabel="Cancelar"
      />
    </ProfaseModal>
  );
}

const s: Record<string, React.CSSProperties> = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 8,
    flexWrap: 'wrap',
  },
};
